import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import NewsRow from '@/components/feature/NewsRow';
import { newsList, hotRanking } from '@/mocks/news';
import { formatHeat } from '@/utils/format';

const latestList = newsList.slice(0, 6);

function NewsBoard() {
  return (
    <section className="w-full px-4 py-14 md:px-8 md:py-20" aria-label="最新快讯与热榜">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-[1fr_340px] lg:gap-12">
        <div>
          <div className="flex flex-wrap items-end justify-between gap-4">
            <SectionHeading
              eyebrow="实时更新"
              title="最新快讯时间线"
              desc="按下一条接一条的时间顺序收录，每条都标注来源与热度，点开即可查看完整事件脉络。"
            />
            <Link
              to="/feed"
              className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
            >
              查看全部快讯
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <div className="mt-8">
            {latestList.map((item, index) => (
              <NewsRow
                key={item.id}
                item={item}
                last={index === latestList.length - 1}
              />
            ))}
          </div>
        </div>

        <aside className="lg:sticky lg:top-24 lg:self-start">
          <div className="rounded-lg border border-background-200/80 bg-background-100 p-5 md:p-6">
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-fire-line" />
              </span>
              <h2 className="font-heading text-lg font-bold text-foreground-950">吃瓜热榜</h2>
            </div>
            <p className="mt-2 text-xs text-foreground-600">
              依据收录条数、讨论增速与转载范围综合估算
            </p>

            <ol className="mt-5 space-y-1">
              {hotRanking.map((item) => (
                <li key={item.rank}>
                  <Link
                    to={`/topic/${item.topicSlug}`}
                    className="group flex items-start gap-3 rounded-md px-2 py-2.5 transition-colors hover:bg-background-200/70"
                  >
                    <span
                      className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-md font-heading text-xs font-bold ${
                        item.rank <= 3
                          ? 'bg-primary-500 text-foreground-950'
                          : 'bg-background-300 text-foreground-800'
                      }`}
                    >
                      {item.rank}
                    </span>
                    <span className="flex-1">
                      <span className="block text-sm leading-snug text-foreground-900 group-hover:text-primary-700">
                        {item.title}
                      </span>
                      <span className="mt-1 inline-flex items-center gap-1 text-xs text-foreground-500">
                        <i className="ri-fire-fill text-accent-600" />
                        {formatHeat(item.heat)}
                      </span>
                    </span>
                  </Link>
                </li>
              ))}
            </ol>
          </div>

          <div className="mt-5 rounded-lg bg-secondary-950 p-5 text-background-100 md:p-6">
            <h3 className="font-heading text-base font-bold text-background-50">
              内容纠错与线索投稿
            </h3>
            <p className="mt-2 text-sm leading-relaxed text-background-200/80">
              发现事件时间线有遗漏，或者手里有更早的信源？把线索发给我们，核实后会补进对应专题。
            </p>
            <Link
              to="/about"
              className="mt-4 inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-foreground-950 transition-colors hover:bg-primary-400"
            >
              <i className="ri-send-plane-line" />
              联系我们
            </Link>
          </div>
        </aside>
      </div>
    </section>
  );
}

export default NewsBoard;